<!--
 * @Description: 
 * @Author: code-shan
 * @Date: 2022-08-11 13:44:06
 * @LastEditTime: 2023-04-27 10:53:04
 * @LastEditors: code-shan
 * @FilePath: \truck-overall-planning\src\components\Page\GlobalFooter.vue
-->
<!--
 * @Description: 
 * @Author: xiaoyao
 * @since: 2020-06-19 18:00:11
 * @LastAuthor: @yangwenshan
 * @lastTime: 2021-10-14 17:19:18
--> 
<template>
  <div class="footer">
    <agreement-modal ref="agreement" />
    <div class="links">
      <!-- <a href="javascript:;" @click="$refs.agreement.show()">服务协议</a> -->
    </div>
    <div class="copyright">Copyright &copy; 2021 成都启点科技有限公司</div>
  </div>
</template>

<script>
import version from "ant-design-vue/lib/version";
import AgreementModal from "@/components/Tools/AgreementModal";
export default {
  name: "LayoutFooter",
  components: {
    AgreementModal,
  },
  data() {
    return {
      version,
    };
  },
};
</script>

<style lang="scss" scoped>
.footer {
  padding: 0 16px;
  margin: 48px 0 24px;
  text-align: center;

  .links {
    margin-bottom: 8px;

    a {
      color: rgba(0, 0, 0, 0.45);

      &:hover {
        color: rgba(0, 0, 0, 0.65);
      }

      &:not(:last-child) {
        margin-right: 40px;
      }
    }
  }
  .copyright {
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Page/GlobalFooter.vue